import React, { useEffect, useState } from 'react';
import {
    Box, Button, FormControl, InputLabel, MenuItem, Select, TextField, Typography
} from '@mui/material';
import { Close } from '@mui/icons-material';
import Datatable from '../../components/Datatable';
import api from '../../services/api';
import { useAuth } from '../../components/AuthProvider';
import moment from 'moment';

const vazio = { userId: '', dateFrom: '', dateTo: '' };

export default function LogAudit() {
    const auth = useAuth();
    const [refresh, setRefresh] = useState(false);
    const [filtros, setFiltros] = useState(vazio);
    const [usuarios, setUsuarios] = useState([]);

    useEffect(() => {
        document.title = 'IPV7 Hermes - Logs de Auditoria';
        // Lista de autores pra escolher em vez de digitar: procurar quem mexeu
        // é a pergunta mais comum aqui, e digitar o nome esbarra em homônimo e
        // em nome que também aparece dentro da mensagem.
        api.post(`/user/${auth.service}`, { limit: 500, offset: 0, order_by: 'name', order: 'asc' })
            .then((res) => setUsuarios(res.data?.data || []))
            .catch(() => setUsuarios([]));
    }, [auth.service]);

    const set = (patch) => setFiltros((prev) => ({ ...prev, ...patch }));
    const sujo = !!(filtros.userId || filtros.dateFrom || filtros.dateTo);

    return (
        <>
            <Box display="flex" alignItems="center" gap={1} flexWrap="wrap" sx={{ mb: 2, px: 1 }}>
                <FormControl size="small" sx={{ minWidth: 220 }}>
                    <InputLabel>Usuário</InputLabel>
                    <Select
                        label="Usuário"
                        value={filtros.userId}
                        onChange={(e) => set({ userId: e.target.value })}
                    >
                        <MenuItem value="">Todos</MenuItem>
                        {usuarios.map((u) => (
                            <MenuItem key={u.id} value={u.id}>
                                {u.name || u.username}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <TextField
                    type="date" size="small" label="De"
                    value={filtros.dateFrom}
                    onChange={(e) => set({ dateFrom: e.target.value })}
                    InputLabelProps={{ shrink: true }} sx={{ width: 160 }}
                />
                <TextField
                    type="date" size="small" label="Até"
                    value={filtros.dateTo}
                    onChange={(e) => set({ dateTo: e.target.value })}
                    InputLabelProps={{ shrink: true }} sx={{ width: 160 }}
                />

                <Button
                    size="small" startIcon={<Close />} disabled={!sujo}
                    onClick={() => setFiltros(vazio)}
                    sx={{ textTransform: 'none' }}
                >
                    Limpar filtros
                </Button>
            </Box>

            <Datatable
                refresh={refresh}
                handlerRefresh={() => setRefresh(!refresh)}
                title='Logs de Auditoria'
                endpoint='/hermes/audit'
                filters={{
                    user_id: filtros.userId || undefined,
                    date_from: filtros.dateFrom || undefined,
                    date_to: filtros.dateTo || undefined,
                }}
                options={{
                    customToolbarSelect: () => ""
                }}
                columns={[
                    {
                        name: 'id',
                        label: "ID",
                        options: { filter: false, sort: false, display: false }
                    },
                    {
                        name: "username",
                        label: 'Usuário',
                    },
                    {
                        name: "message",
                        label: 'Mensagem',
                    },
                    {
                        name: "created_at",
                        label: "Data",
                        options: {
                            customBodyRender: value => (
                                <span>{moment(value).locale('pt-br').format('DD/MM/YYYY HH:mm:ss')}</span>
                            ),
                        }
                    },
                ]}
            />
        </>
    )
}
